import { render, staticRenderFns } from "./free-downloads.vue?vue&type=template&id=6822b5f8&"
import script from "./free-downloads.vue?vue&type=script&lang=tsx&"
export * from "./free-downloads.vue?vue&type=script&lang=tsx&"
import style0 from "./free-downloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports